// extracted by mini-css-extract-plugin
module.exports = {"vGray0":"#b9b9dc","group":"TicketMessageGroup_group__TeWA1","dateWrap":"TicketMessageGroup_dateWrap__lvT5K","date":"TicketMessageGroup_date__2AM8v"};